<template>
  <v-container fluid>
    <v-card>
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Empresas</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn fab small color="primary lighten-4" @click="tooglePesquisa" class="mx-2">
          <v-icon>search</v-icon>
        </v-btn>
        <v-btn
          depressed
          color="primary lighten-4"
          @click="$router.push('empresas/cadastrar')"
          class="hidden-xs-only"
        >Adicionar</v-btn>
        <v-btn
          fab
          small
          color="primary lighten-4"
          @click="$router.push('produtos/adicionar')"
          class="hidden-sm-and-up"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-app-bar>

      <v-expand-transition>
        <v-row dense v-show="exibirPesquisa" class="pa-2">
          <v-col cols="12" pa-2>
            <v-text-field
              ref="pesquisa"
              label="Pesquisa"
              v-model="pesquisa"
              prepend-inner-icon="search"
              solo
              clearable
              single-line
              hide-details
              placeholder="Pesquisa"
              dark
              background-color="primary lighten-2"
              @click:clear="tooglePesquisa"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-expand-transition>

      <v-data-table
        :search="pesquisa"
        :headers="headers"
        :items="lojas"
        :loading="loading"
        no-data-text="Sem registros"
        no-results-text="Sem registros"
        loading-text="Carregando dados..."
        :items-per-page="30"
        :footer-props="{ itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }], itemsPerPageText: '' }"
      >
        <template v-slot:item.opcoes="{ item }">
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item @click="$router.push('/empresas/' + item.id + '/editar')">
                <v-list-item-title>
                  <v-icon class="pr-4">edit</v-icon>Editar
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="abrirModalExcluir(item)" :disabled="!!item.padrao">
                <v-list-item-title>
                  <v-icon :disabled="!!item.padrao" class="pr-4">close</v-icon>Excluir
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>

    <as-dialogo ref="dialogoExcluir" title="Excluir Empresa" max-width="440px" hideCloseButton>
      <v-label>Tem certeza que deseja excluir essa empresa?</v-label>
      <div slot="botoes" class="pa-2">
        <v-btn depressed class="mr-4" @click="$refs.dialogoExcluir.fechar()">Cancelar</v-btn>
        <v-btn depressed color="error" @click="excluir" :loading="loading">Excluir</v-btn>
      </div>
    </as-dialogo>
  </v-container>
</template>

<script>
import ServiceLojas from "../services/lojas.js";
import Services from "../services/services.js";

export default {
  name: "Lojas",
  data() {
    return {
      pesquisa: "",
      user: {},
      exibirPesquisa: false,
      loja: {
        id: "",
        cliente_id: "",
        endereco_id: "",
        cnpj: "",
        ie: "",
        nome_fantasia: "",
        razao_social: "",
        responsavel_id: "",
        logo: "",
        endereco: {
          id: "",
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cidade: "",
          estado: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
        responsavel: {
          id: "",
          cpf: "",
          nome: "",
          endereco_id: "",
          endereco: {
            id: "",
            rua: "",
            numero: "",
            complemento: "",
            bairro: "",
            cidade_id: "",
            estado_id: "",
            cidade: "",
            estado: "",
            cep: "",
            telefone: "",
            celular: "",
            email: "",
          },
        },
      },
      erros: {
        loja: {
          cnpj: "",
          nome_fantasia: "",
          razao_social: "",
          endereco: {
            rua: "",
            numero: "",
            bairro: "",
            cidade: "",
            estado: "",
            cep: "",
            telefone: "",
            celular: "",
            email: "",
          },
          responsavel: {
            cpf: "",
            nome: "",
            endereco: {
              rua: "",
              numero: "",
              bairro: "",
              cidade: "",
              estado: "",
              cep: "",
              telefone: "",
              celular: "",
              email: "",
            },
          },
        },
      },
      modal: false,
      modalExcluir: false,
      modalExcluirPadrao: false,
      lojas: [],
      estados: [],
      cidadesLoja: [],
      cidadesResponsavel: [],
      loading: false,
      title: "",
      lojaSel: -1,
      headers: [
        { text: "Razão Social", value: "razao_social", width: "35%" },
        { text: "Nome Fantasia", value: "nome_fantasia", width: "35%" },
        { text: "CNPJ", value: "cnpj", width: "25%" },
        { text: "", value: "opcoes", width: "5%", sortable: false },
      ],
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.listar();
  },
  methods: {
    async listar() {
      try {
        this.loading = true;
        let response = await ServiceLojas.index(this.user.cliente_id);
        if (response.data.status == 1) {
          this.lojas = response.data.lojas;
        } else {
          if (response.data.status == 401) {
            this.$root.$children[0].makeLogOff = true;
          }
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar empresas");
      } finally {
        this.loading = false;
      }
    },
    abrirModalExcluir(empresa) {
      this.loja = empresa;
      this.$refs.dialogoExcluir.abrir();
    },
    async excluir() {
      try {
        this.loading = true;
        let response = await ServiceLojas.excluir(
          this.user.cliente_id,
          this.loja.id
        );
        this.$eventbus.notificar("Empresa excluída com sucesso");
        this.listar();
      } catch (error) {
        console.log(error);
        this.$eventbus.erro(error.response.data.msg);
      } finally {
        this.$refs.dialogoExcluir.fechar();
        this.loading = false;
      }
    },
    zerarLoja() {
      this.loja = {
        id: "",
        cliente_id: "",
        endereco_id: "",
        cnpj: "",
        ie: "",
        nome_fantasia: "",
        razao_social: "",
        responsavel_id: "",
        logo: "",
        endereco: {
          id: "",
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cidade: "",
          estado: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
        responsavel: {
          id: "",
          cpf: "",
          nome: "",
          endereco_id: "",
          endereco: {
            id: "",
            rua: "",
            numero: "",
            complemento: "",
            bairro: "",
            cidade_id: "",
            estado_id: "",
            cidade: "",
            estado: "",
            cep: "",
            telefone: "",
            celular: "",
            email: "",
          },
        },
      };
      this.erros = {
        loja: {
          cnpj: "",
          nome_fantasia: "",
          razao_social: "",
          endereco: {
            rua: "",
            numero: "",
            bairro: "",
            cidade: "",
            estado: "",
            cep: "",
            telefone: "",
            celular: "",
            email: "",
          },
          responsavel: {
            cpf: "",
            nome: "",
            endereco: {
              rua: "",
              numero: "",
              bairro: "",
              cidade: "",
              estado: "",
              cep: "",
              telefone: "",
              celular: "",
              email: "",
            },
          },
        },
      };
    },

    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
  },
};
</script>

<style></style>
